<template>
  <a-modal :title="form.tripday_id ? '修改出行信息' : '新增出行信息'" :visible="visible" :confirm-loading="confirmLoading"
    @ok="handleOk" @cancel="handleCancel" destroyOnClose :maskClosable="false" width="800px">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="出行日期" prop="day">
        <a-date-picker v-model="form.day" style="width: 100%;" :format="'YYYY/MM/DD'"
          :valueFormat="'YYYY/MM/DD 00:00:00'" />
      </a-form-model-item>
      <a-form-model-item ref="title" label="行程地点" prop="title">
        <a-input v-model="form.title" placeholder="行程地点" />
      </a-form-model-item>
      <a-form-model-item ref="subtitle" label="行程配置" prop="subtitle">
        <a-textarea v-model="form.subtitle" placeholder="例如：车、酒店等" :auto-size="{ minRows: 3}" />
      </a-form-model-item>
      <a-form-model-item ref="detail" label="详细计划" prop="detail">
        <a-textarea v-model="form.detail" placeholder="行程详细计划（例如上午或下午的详细计划）" :auto-size="{ minRows: 3}" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import "element-ui/lib/theme-chalk/index.css";
export default {
  props: ['trip_id'],
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: {
        tripday_id: "",
        day: "",
        title: "",
        subtitle: "",
        detail: ''
      },
      treeData: [],
      groupList: [],
      loadingGroup: false,
      rules: {
        day: [
          {
            required: false,
            message: "请选择出行日期",
            trigger: "change",
          },
        ],
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
  },
  methods: {
    handleCheck(node, checkedNodes) {
      // 获取所有选中的节点 ID
      this.form.menu_power = checkedNodes.checkedKeys;
    },
    init(id) {
      this.visible = true;
      this.form.tripday_id = id;
      if (id) {
        this.$http({
          url: "/admin/tripdays/info",
          method: "post",
          data: {
            id: id,
          },
        }).then((res) => {
          this.form = {
            ...res.data
          }
        });
      }
    },
    changeStatus(bol) {
      this.form.role_status = bol ? "1" : "2";
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          const form = {
            ...this.form,
            trip_id: this.trip_id
          };
          this.$http({
            url: this.form.tripday_id ? "/admin/tripdays/update" : "/admin/tripdays/create",
            method: "post",
            data: form,
          })
            .then(() => {
              this.$message.success(this.form.tripday_id ? "修改成功" : "创建成功");
              this.handleCancel();
              this.$emit("ok");
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>

<style>
.custom-tree-node {
  display: flex;
  width: 100%;
  /* border: 1px solid red; */
}
</style>